


































import {defineComponent, PropType, ref} from "@vue/composition-api";
import ProjectLayout from "@tool/Pages/App/Project/layout/ProjectLayout.vue";
import useInertiaTable from "@tool/Helpers/useInertiaTable";
import InertiaDatatable from "@base/Components/InertiaDatatable.vue";
import CopyInputGroup from "@base/Components/CopyInputGroup.vue";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import {useToast} from "vue-toastification/composition";
import {ProjectEntityInterface, ShorturlEntityInterface, UrlEntityInterface} from "@tool/tool.types";
import {BuilderUrlInterface} from "@tool/Builder/Builder.types";
import {ResourceCollectionInterface} from "@base/base.types";
import useSwal from "@tool/Helpers/useSwal";
import {useInertia} from "@tool/Helpers/useInertia";
import useAxios from "@tool/Helpers/useAxios";
import useRequiresUpgradeAlerts from "@tool/Helpers/useRequiresUpgradeAlerts";

export default defineComponent({
    components: {
        ProjectLayout,
        InertiaDatatable,
        CopyInputGroup,
        ThemeBlock
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        canManageShorturls: {
            type: Boolean,
            required: true
        },
        urls: {
            type: Object as PropType<ResourceCollectionInterface<UrlEntityInterface>>,
            required: true
        }
    },
    setup(props) {

        const table = useInertiaTable(props.urls, [
            {
                key: 'full_url',
                label: 'Full UTM Url'
            },
            {
                key: 'shorturl',
                label: 'Short Url'
            },
            {
                key: 'clicks',
                label: 'Clicks'
            },
            {
                key: 'actions',
                label: 'Actions',
                class: 'actions'
            },
        ]);

        const buildSimilarLink = (urlId: string) => {
            return route('app.project.builder.index', {
                tool_project_entity: props.project.slug,
                build_from_url: urlId
            });
        }

        const shortenUrlProcessing = ref(false);
        const toast = useToast();

        const shortenUrlSubmit = async (url: BuilderUrlInterface) => {
            if (!props.canManageShorturls) {
                return useRequiresUpgradeAlerts().shorturlsManagement(props.project.team_id);
            }

            shortenUrlProcessing.value = true;
            try {
                const response = await useAxios().post<ShorturlEntityInterface>(route('app.project.urls.shorten', {
                    'tool_project_entity': props.project.slug,
                    'tool_url_entity': url.id
                }));

                url.shorturls.push(response.data);

                toast.success('Url was successfully shortened!');
            } catch (e) {
                toast.error('Oops! Something went wrong with shortening your url.');
            }
            shortenUrlProcessing.value = false;
        }

        return {
            table,
            buildSimilarLink,
            shortenUrlSubmit,
            shortenUrlProcessing
        }
    }
});
